import React from 'react';

import InfoLayoverTag from './InfoLayoverTag/InfoLayoverTag';

const FlightInfoLayover = (props) => {
    let textJSX = null;

    if(props.type === "layover") {
        textJSX = 
            <p className={`u-backgroundColorDarkGrey u-flexCenter u-textColorDark u-textAlignCenter u-relative u-fontSize11 u-borderRadius4 u-height24`}>
                <InfoLayoverTag type={1}>Layover</InfoLayoverTag>
                Layover in&nbsp;<span className={`u-fontWeightMedium`}>{props.originCity} | {props.layoverTime}</span>
            </p>
    }
    if(props.type === "transitVisa") {
        textJSX = 
            <p className={`u-backgroundColorVisa u-flexCenter u-textColorDark u-textAlignCenter u-relative u-fontSize11 u-borderRadius4 u-height24`}>
                <InfoLayoverTag type={2}>Visa</InfoLayoverTag>
                Transit Visa is required in&nbsp;<span className={`u-fontWeightMedium`}>{props.originCity}</span>&nbsp;for Indian Nationals.
            </p>
    }
    if (props.type === "handBaggage") {
        textJSX = 
            <p className={`u-backgroundColorHandBaggage u-flexCenter u-textColorDark u-textAlignCenter u-relative u-fontSize11 u-borderRadius4 u-height24`}>
                <InfoLayoverTag type={3}>Hand Baggage</InfoLayoverTag>
                <span className="u-phoneHide">This is a special&nbsp;</span><span className={`u-fontWeightMedium`}>Hand Baggage only fare</span>&nbsp;provided by the airlines.
            </p>
    }

    return (textJSX);
};

export default FlightInfoLayover;


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoLayover/FlightInfoLayover.js